export const userConstants = {
  GET_ALL_USER_SUCCESS: "app/user/GET_ALL_USER_SUCCESS",
  GET_ALL_USER_COPY_SUCCESS: "app/user/GET_ALL_USER_COPY_SUCCESS",
  GET_ALL_USER_FAILURE: "app/user/GET_ALL_USER_FAILURE",
  GET_USER_DETAIL_SUCCESS: "app/user/GET_USER_DETAIL_SUCCESS",
  GET_USER_DETAIL_FAILURE: "app/user/GET_USER_DETAIL_FAILURE",
};
